<template>
  <!-- eslint-disable vue/no-v-html -->
  <v-row class="py-1" align="center" justify="space-between">
    <v-col class="py-0 pr-0" cols="4">
      <span class="text--secondary">{{rule.label}}</span>
    </v-col>
    <v-col class="pa-0" cols="7">
      <v-row align="center" justify="space-between">
        <!-- list of operands (optional) -->
        <v-col class="py-0" cols="6" v-if="typeof rule.operands !== 'undefined'">
          <v-select v-model="query.operand" :items="rule.operands" return-object outlined single-line dense background-color="white" hide-details />
        </v-col>

        <!-- list of operators (e.g. =, !=, >, <) -->
        <v-col class="py-0" cols="6" v-if="typeof rule.operators !== 'undefined' && rule.operators.length > 1">
          <v-select v-model="query.operator" :items="rule.operators" return-object outlined single-line dense background-color="white" hide-details />
        </v-col>

        <!-- query -->
        <v-col class="py-0" :cols="typeof rule.operands !== 'undefined' || (typeof rule.operators !== 'undefined' && rule.operators.length > 1) ? 6 : 12">
          <!-- basic text input -->
          <v-text-field v-if="rule.inputType === 'text'" v-model.trim="query.value" background-color="white" outlined required  single-line dense hide-details />

          <!-- basic number input -->
          <v-text-field v-if="rule.inputType === 'number'" v-model.number="query.value" background-color="white" outlined required  single-line dense hide-details />

          <!-- Datepicker -->
          <input v-if="rule.inputType === 'date'" v-model="query.value" class="form-control" type="date">

          <!-- Custom component input -->
          <div v-if="isCustomComponent" class="vqb-custom-component-wrap">
            <component :is="rule.component" :value="query.value" @input="updateQuery" />
          </div>

          <!-- Checkbox input -->
          <template v-if="rule.inputType === 'checkbox'">
            <div v-for="choice in rule.choices" :key="choice.value" class="form-check form-check-inline">
              <input :id="'depth' + depth + '-' + rule.id + '-' + index + '-' + choice.value" v-model="query.value" type="checkbox" :value="choice.value" class="form-check-input">
              <label class="form-check-label" :for="'depth' + depth + '-' + rule.id + '-' + index + '-' + choice.value">{{choice.label}}</label>
            </div>
          </template>

          <!-- radio input -->
          <v-radio-group v-if="rule.inputType === 'radio'" v-model="query.value" row>
            <v-radio v-for="choice in rule.choices" :key="choice.value" :name="'depth' + depth + '-' + rule.id + '-' + index" :label="choice.label" :value="choice.value"></v-radio>
          </v-radio-group>

          <!-- Select without groups -->
          <v-select v-if="rule.inputType === 'select' && !hasOptionGroups" v-model="query.value" :items="Object.values(selectOptions)" item-text="label" item-value="value" outlined single-line dense background-color="white" hide-details />

          <!-- Select with groups -->
          <v-select v-if="rule.inputType === 'select' && hasOptionGroups" v-model="query.value" :items="Object.values(selectOptions)" item-text="label" item-value="value" outlined single-line dense background-color="white" hide-details />
        </v-col>
      </v-row>
    </v-col>
    <v-col class="py-0" cols="1">
      <v-btn @click="remove" icon small color="red"><v-icon small>mdi-close</v-icon></v-btn>
    </v-col>
  </v-row>
</template>
<script>
import QueryBuilderRule from 'vue-query-builder/src/components/QueryBuilderRule'
export default {
  extends: QueryBuilderRule
}
</script>